// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconEdit = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M21.5 7.5L8 21H3v-5L16.5 2.5zm-7.823.651L5 16.828V19h2.172l8.677-8.677zm3.586.758L18.672 7.5 16.5 5.328l-1.409 1.41z"
    />
  );
export default SvgIconEdit;
